<template>
  <div class="added-service">
    <!-- <HeaderTop></HeaderTop> -->
    <!-- <Header :page="3"></Header> -->
    <div class="banner flex-align-center">
      <img src="../../assets/home/12345678.png" alt="" />
    </div>
    <div class="service-box main">
      <div class="main-bav flex-align-between">
        <div class="bav-left">
          <img src="../../assets/home/789.png" alt="" />
        </div>
        <div class="bav-right">
          <div class="container">
            提高在校书法及语文教师的教学能力和书写能力，解决校外培训机构教师书写技能、
            教学水平和和书画等级考试辅导等方面的难题，稳定做好中小学书法教育培训工作，
            落实教育部考试中心关于加强书法教师培训，持证上岗的文件精神。
          </div>
          <div class="apply" @click="toBottom">如何申请 &gt;</div>
        </div>
      </div>

      
      <div class="object">
        <div class="object-top flex-column-center">
          <p>培训对象</p>
          <p class="flex-align-center"><span></span></p>
        </div>
          <div class="series-list flex-align-wrap">
               <div class="series-item" v-for="(item,index) in TeachingList" :key="index">
                 <div class="item-board">
                   <img :src="item.icon" alt=""/>
                   <div class="heng"></div>
                   <p >{{item.name1}}</p>
                   <p >{{item.name}}</p>

                 </div>
               </div>
             </div>
          <!-- <img src="../../assets/home/WX20211126-151726.png" alt="" /> -->
      </div>
      <!-- <div class="curriculum">
        <div class="curriculum-top flex-column-center">
          <p>培训课程体系</p>
          <p class="flex-align-center"><span></span></p>
        </div>
        <div class="flex-align-center">
          <img src="../../assets/home/WX20211126-151651.png" alt="" />
        </div>
      </div> -->
      <!-- <div class="ceremony">
        <div class="ceremony-top flex-column-center">
          <p>授牌仪式精彩回顾</p>
          <p class="flex-align-center"><span></span></p>
        </div>
        <div class="img-list">
          <div class="img-top flex-align-between">
            <img src="../../assets/home/1.png" alt="" />
            <img src="../../assets/home/2.png" alt="" />
          </div>
          <div class="img-center flex-align-between">
            <img src="../../assets/home/2.png" alt="" />
            <img src="../../assets/home/1.png" alt="" />
          </div>
          <div class="img-bottom flex-align-between">
            <img src="../../assets/home/2.png" alt="" />
            <img src="../../assets/home/2.png" alt="" />
            <img src="../../assets/home/2.png" alt="" />
          </div>
        </div>
      </div> -->
      <div class="message">
        <div class="message-top flex-column-center">
          <p>如果您对师训服务感兴趣，请在下方留言或拨打电话联系我们</p>
          <p class="flex-align-center"><span></span></p>
        </div>
        <div class="message-box flex-align-between">
          <div class="message-box-left">
            <el-form ref="form" :model="form" label-width="120px">
              <el-form-item>
                <el-row
                  type="flex"
                  class="row-bg"
                  justify="space-between"
                  :gutter="30"
                >
                  <el-col :span="20">
                    <el-input
                      placeholder="姓名"
                      v-model="form.name"
                    ></el-input>
                  </el-col>
                  <el-col :span="20">
                    <el-input
                      placeholder="手机号码"
                      v-model="form.phone"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item>
                <el-input placeholder="邮箱" v-model="form.address"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  rows='6'
                  type="textarea"
                  placeholder="留言......."
                  v-model="form.comment"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-row type="flex" class="row-bg" justify="end">
                  <div class="button">
                    <div class="button-left pointer"  @click="onSubmit">提交</div>
                    <div class="button-right pointer">重置</div>
                    <div></div>
                  </div>
                </el-row>
                <!-- <el-row type="flex" class="row-bg" justify="end">
                  <el-col :span="12" :offset="6">
                    <el-button type="danger" @click="onSubmit">提交</el-button>
                    <el-button type="danger" plain>重置</el-button>
                  </el-col>
                </el-row> -->
              </el-form-item>
            </el-form>
          </div>
          <div class="message-box-right">
            <div class="contact">
              <div class="contact-img"><img src="../../assets/home/base/map.png" alt=""></div>
              <div class="contact-top flex-align-center">
                <p>联系我们</p>
              </div>
              <div class="contact-bottom flex-evenly">
                <p><img src="../../assets/home/icon/phone.png" alt=""></p>
                <p>
                  张老师
                  <br>
                  13718568030（微信同号）
                  <br>
                  yd@lezhireading.com
                  <br>
                  010-88512948
                </p>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
       form: {
          name: '',
          phone: '',
          address: '',
          comment: '',
          
        },
        TeachingList:[
            {
              name1:'幼儿园',
              name:'教师',
              icon:require(`../../assets/home/base/yey.png`),
            },{
              name1:'公立校、私立校',
              name:'教师',
              icon:require(`../../assets/home/base/glxx.png`),
            },{
              name1:'师范院校',
              name:'在校生',
              icon:require(`../../assets/home/base/sfx.png`),
            },{
              name1:'书画等级考试组考',
              name:'单位任课教师',
              icon:require(`../../assets/home/base/sh.png`),
            },{
              name1:'培训机构',
              name:'辅导教师',
              icon:require(`../../assets/home/base/px.png`),
            }
          ]
    };
  },
  computed: {},
  methods: {
    toBottom(){
      var height = document.body.clientHeight;
      window.scroll({ top: height , left: 0, behavior: 'smooth' });
    },
   onSubmit() {
       if(!this.form.name) {
         this.$message.error('请填写姓名。');
         return
       }
       if(!this.form.phone) {
         this.$message.error('请填写正确的手机号码。');
         return
       }
       if(!this.form.address) {
         this.$message.error('请填写邮箱账号。');
         return
       }
       if(!this.form.comment) {
         this.$message.error('请填写留言信息。');
         return
       }
       let params = {
          name:this.form.name,
          phone:this.form.phone ,
          address: this.form.address,
          comment: this.form.comment
        }
        Api.Home.getComment(this.form).then((result) => {
          console.log(result)
          if(result.code == 200) {
            this.$notify({
              title: '成功',
              message: result.msg,
              type: 'success'
            });
          }
        }).catch((err) => {
          console.log(err)
        });
      }
  },
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="less">
@import "./less/news_common.less";
@basisColor: #1c4b90;
@bgColor: #eef3f6;
@white: #fff;
.added-service {
  background-color: @white;
  .el-form .el-form-item .el-form-item__content {
    margin-left:0 !important;
  }
  .main {
    width: 1200px;
    margin: 0 auto;
  }
  .service-box {
    .main-bav {
      padding-top: 45px;
      .bav-left {
        width: 564px;
        height: 432px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .bav-right {
        background-image: url("../../assets/home/teach.png");
        background-repeat: no-repeat;
        height: 432px;
        width: 606px;
        background-size: cover;
        background-position: 50% 0;
        .container {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 35px;
          padding: 110px 76px 50px;
        }
        .apply {
          float: right;
          width: 150px;
          margin: 0px 76px;
          text-align: center;
          border-radius: 6px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 36px;
          background: #cc4c4d;
          cursor: pointer;
          &:hover{
            // box-shadow: 0 0 20px #c8c8c8;
            // padding:2px;
            margin-top:-5px;
            transition-duration: 500ms;
            // transform: translateY(-6px);
            // -moz-transform: translateY(-6px);
            // -o-transform: translateY(-6px);
            // -webkit-transform: translateY(-6px);
          }
        }
      }
    }
    .object {
      padding-top: 30px;
      .object-top {
        p:nth-child(1) {
          // padding-top:40px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #666666;
        }
        p:nth-child(2) {
          width: 200px;
          background: #ececec;
          height: 1px;
          margin: 20px 0;
          // border: 1px solid #666666;
          // position: relative;
          span {
            // position: ;
            display: inline-block;
            width: 44px;
            height: 6px;
            background: #cc4c4d;
          }
        }
      }
      .series-list {
          width: 100%;
          .series-item {
            margin-right:15px;
            width: calc((100% / 5) - 15px );
            padding:30px 0;
            .item-board {
              padding:20px;
            background: #FFFDFE;
            border: 1px solid #E9E9E9;
            border-radius: 5px;
              img {
                width: 188px;
                height: 214px;

              }
              .heng {
                width: 43px;
                height: 2px;
                background: #CC4C4D;
                margin:28px auto;
              }
              p {
                width: 174px;
                text-align: center;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                line-height: 24px;
              //   overflow:hidden; 
              // text-overflow:ellipsis;
              // display:-webkit-box; 
              // -webkit-box-orient:vertical;
              // -webkit-line-clamp:2; 
              }
            }
          }
        }
    }
    .curriculum {
      padding-top: 30px;
      .curriculum-top {
        p:nth-child(1) {
          // padding-top:40px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #666666;
        }
        p:nth-child(2) {
          width: 200px;
          background: #ececec;
          height: 1px;
          margin: 20px 0;
          // border: 1px solid #666666;
          // position: relative;
          span {
            // position: ;
            display: inline-block;
            width: 44px;
            height: 6px;
            background: #cc4c4d;
          }
        }
      }
    }
    .ceremony {
      .ceremony-top {
        p:nth-child(1) {
          // padding-top:40px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #666666;
        }
        p:nth-child(2) {
          width: 200px;
          background: #ececec;
          height: 1px;
          margin: 20px 0;
          // border: 1px solid #666666;
          // position: relative;
          span {
            // position: ;
            display: inline-block;
            width: 44px;
            height: 6px;
            background: #cc4c4d;
          }
        }
      }
      .img-list {
        .img-top {
          padding: 8px 0;
          img:nth-child(1) {
            width: 794px;
            height: 258px;
          }
          img:nth-child(2) {
            width: 389px;
            height: 258px;
          }
        }
        .img-center {
          padding: 8px 0;
          img:nth-child(2) {
            width: 794px;
            height: 258px;
          }
          img:nth-child(1) {
            width: 389px;
            height: 258px;
          }
        }
        .img-bottom {
          padding: 8px 0;
          img {
            width: 386px;
            height: 259px;
          }
        }
      }
    }

     .message {
      padding: 30px 0;
      .message-top {
        p:nth-child(1) {
          // padding-top:40px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #666666;
        }
        p:nth-child(2) {
          width: 200px;
          background: #ececec;
          height: 1px;
          margin: 20px 0;
          // border: 1px solid #666666;
          // position: relative;
          span {
            // position: ;
            display: inline-block;
            width: 44px;
            height: 6px;
            background: #cc4c4d;
          }
        }
      }
      .message-box {
        .message-box-left {
          flex: 2;
            .el-input__inner:focus,
            .el-textarea .el-el-textarea__inner:focus {
              border-color: #dcdfe6;
            }
            .button {
              display: flex;
              .button-left  {
                text-align: center;
                background: #cc4c4d;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 34px;
                width: 130px;
                cursor: pointer;
              }
              .button-right {
                cursor: pointer;
                margin-left:30px;
                width: 130px;
                text-align: center;

                background: #FFFFFF;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                line-height: 33px;
                border: 1px solid #c9c9c9;
              }
            }
        }
        .message-box-right {
          flex: 1;
          padding:20px 15px;
          margin-left:50px;
            border: 1px solid #E6E6E6;
            border-radius: 10px;
          .contact {
            width: 284px;
            .contact-img {
              padding:0 0 10px 0;
              img {
                width: 368px;
                height: 169px;
              }
            }
            .contact-top {
              background-image: url("../../assets/home/base/ban.png");
              background-repeat: no-repeat;
              height: 61px;
              width: 368px;
              background-size:cover;
              background-position: 50% 0;
              p {
                // text-align: center;
                // padding-left:20px;
                font-size: 22px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 30px;
              }
            }
            .contact-bottom{
              padding-top:30px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #bcbcbc;
              line-height: 30px;
            }
          }
        }
              
      }
    }
  }
}
</style>
